<div class="card-base">
    <div class="card-content-operation">
        <div class="card-container mat-elevation-z1">
            <div class="card-content">
                <form [formGroup]="form">
                    <app-medical-order-operation-control-component formControlName="MedicalOrderOperation">
                    </app-medical-order-operation-control-component>
                </form>
            </div>
            <div *ngIf="returnurl" class="card-footer margin-top-medium">
                <button color="primary" [disabled]="loading" mat-flat-button (click)="finish()">Finalizar</button>
            </div>
        </div>
    </div>
</div>
